module.exports = __webpack_public_path__ + "img/7_30.a4f953ce.png";